import React, { useState } from 'react'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import Background from '../../assets/backgrounds/about.svg'
import BackgroundMobile from '../../assets/backgrounds/about-mobile.svg'
import Intro from './components/Intro'
import Team from './components/Team'
import Join from './components/Join'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'
import AboutSummary from '../HomePage/components/AboutSummary/AboutSummary'

const About = () => {
    const [padding, setPadding] = useState<PaddingProps>()

    return (
        <PaddingContext.Provider value={{ padding }}>
            <PageHeader
                title='page.about.title'
                bgColor={Color.PURPLE}
                component={Background}
                mobileComponent={BackgroundMobile}
                link={'/'}
            />
            <div className='bg-white'>
                <AboutSummary setPadding={setPadding} />
                <Intro setPadding={setPadding} />
                <Team />
                <Join />
            </div>
        </PaddingContext.Provider>
    )
}

export default About
